/* projects/speaker-platform/src/app/organisms/admin/texts-list/texts-list.component.scss */
.textslist__header {
  position: sticky;
  z-index: 3;
  top: 0;
  background-color: white;
}
.textslist__table thead {
  position: sticky;
  z-index: 2;
}
.textslist__table thead tr th {
  position: sticky;
  top: 0;
  box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
  font-size: 14px;
  font-weight: 700;
}
.textslist__table__loader {
  display: inline-block;
  padding: 32px 0;
  transform: scale(2.5);
}
.textslist__table__empty {
  padding: 32px 0;
  text-align: center;
  color: #952626;
}
.textslist__table__select {
  position: relative;
}
.textslist__table__select--linked::before {
  display: inline-block;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  position: absolute;
  left: -18px;
  font-size: 12px;
  content: "\f0c1";
}
.textslist__table__select--match {
  background-color: rgba(255, 237, 0, 0.25);
}
.textslist__error {
  color: #952626;
  font-size: 14px;
}
.textslist__translationstatus {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: red;
}
.textslist__translationstatus--sent {
  background-color: #FFC107;
}
.textslist__translationstatus--done {
  background-color: #99FF74;
}
/*# sourceMappingURL=texts-list.component-RJRVVZLL.css.map */
